var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "major" }, [
    _c("div", { staticClass: "typeOf" }, [_vm._v("类型")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "vanTabsItem" },
      [
        _c(
          "van-tabs",
          {
            on: {
              change: function() {
                return _vm.changeTabs(_vm.active)
              }
            },
            model: {
              value: _vm.active,
              callback: function($$v) {
                _vm.active = $$v
              },
              expression: "active"
            }
          },
          _vm._l(_vm.tabArray, function(tab, index) {
            return _c("van-tab", { key: index, attrs: { title: tab } }, [
              _c(
                "div",
                { staticClass: "padding20X paddingX14 van-bgcolor-white" },
                [
                  _vm.active === 0
                    ? [
                        _c(
                          "van-form",
                          {
                            ref: "ruleForm",
                            refInFor: true,
                            staticClass: "tab1Form castForm"
                          },
                          [
                            _c("p", { staticClass: "tab1Form-item-label" }, [
                              _vm._v("币种"),
                              _c("span", [_vm._v("(必填)")])
                            ]),
                            _vm._v(" "),
                            _c("cu-field", {
                              attrs: {
                                name: "currency",
                                placeholder:
                                  "请输入最多4个英文字母字符，例如sats",
                                rules: [
                                  { required: true, message: "请输入币种" },
                                  {
                                    validator: _vm.validatorWithCurrency,
                                    message: "请输入最多4个英文字母字符"
                                  }
                                ]
                              },
                              model: {
                                value: _vm.cast.currency,
                                callback: function($$v) {
                                  _vm.$set(_vm.cast, "currency", $$v)
                                },
                                expression: "cast.currency"
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "tab1Form-item-label" }, [
                              _vm._v("数量"),
                              _c("span", [_vm._v("(必填)")])
                            ]),
                            _vm._v(" "),
                            _c("cu-field", {
                              attrs: {
                                name: "amount",
                                placeholder: " 请输入数量",
                                rules: [
                                  { required: true, message: "请输入数量" }
                                ]
                              },
                              model: {
                                value: _vm.cast.amount,
                                callback: function($$v) {
                                  _vm.$set(_vm.cast, "amount", $$v)
                                },
                                expression: "cast.amount"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "tab1Form-item-label selectAddress"
                              },
                              [
                                _c("div", [
                                  _vm._v(_vm._s(_vm.inpWayText) + "接收地址"),
                                  _c("span", [_vm._v("(必填)")])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.changeInpAdWay()
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../assets/images/dmtAorrow.png")
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.selectWayText) +
                                        "接收地址\n                "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isSelect
                              ? _c("van-field", {
                                  attrs: {
                                    name: "address",
                                    readonly: "",
                                    clearable: "",
                                    rules: [
                                      { required: true, message: "请选择地址" }
                                    ],
                                    placeholder: "请选择地址"
                                  },
                                  on: { click: _vm.showAdSelect },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "button",
                                        fn: function() {
                                          return [
                                            _c("van-icon", {
                                              attrs: { name: "arrow-down" }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.cast.address,
                                    callback: function($$v) {
                                      _vm.$set(_vm.cast, "address", $$v)
                                    },
                                    expression: "cast.address"
                                  }
                                })
                              : _c("cu-field", {
                                  attrs: {
                                    name: "address",
                                    placeholder: "请输入地址",
                                    rules: [
                                      { required: true, message: "请输入地址" }
                                    ]
                                  },
                                  model: {
                                    value: _vm.cast.address,
                                    callback: function($$v) {
                                      _vm.$set(_vm.cast, "address", $$v)
                                    },
                                    expression: "cast.address"
                                  }
                                })
                          ],
                          1
                        )
                      ]
                    : _vm.active === 1
                    ? [
                        _c(
                          "van-form",
                          {
                            ref: "ruleForm",
                            refInFor: true,
                            staticClass: "tab1Form transfer"
                          },
                          [
                            _c("div", { staticClass: "form-item" }, [
                              _c("p", { staticClass: "tab1Form-item-label" }, [
                                _vm._v("币种")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "tab1Form-item-value" },
                                [
                                  _c(
                                    "van-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showTransferSelect(
                                            "currency"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.transfer.currency
                                            ? _vm.transfer.currency
                                            : "选择币种"
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-item" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "tab1Form-item-label selectAddress"
                                  },
                                  [
                                    _c("div", [
                                      _vm._v("可转余额"),
                                      _c("span", [_vm._v("(必填)")])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.tranBalance()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    新增可转余额\n                "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("cu-field", {
                                  attrs: {
                                    name: "id",
                                    placeholder: "请输入可转余额",
                                    rules: [
                                      {
                                        required: true,
                                        message: "请输入可转余额"
                                      }
                                    ]
                                  },
                                  model: {
                                    value: _vm.cast.id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.cast, "id", $$v)
                                    },
                                    expression: "cast.id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "tab1Form-item-label selectAddress"
                              },
                              [
                                _c("div", [
                                  _vm._v(_vm._s(_vm.inpWayText) + "接收地址"),
                                  _c("span", [_vm._v("(必填)")])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.changeInpAdWay()
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../assets/images/dmtAorrow.png")
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.selectWayText) +
                                        "接收地址\n                "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isSelect
                              ? _c("van-field", {
                                  attrs: {
                                    name: "address",
                                    readonly: "",
                                    clearable: "",
                                    rules: [
                                      { required: true, message: "请选择地址" }
                                    ],
                                    placeholder: "请选择地址"
                                  },
                                  on: { click: _vm.showAdSelect },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "button",
                                        fn: function() {
                                          return [
                                            _c("van-icon", {
                                              attrs: { name: "arrow-down" }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.transfer.address,
                                    callback: function($$v) {
                                      _vm.$set(_vm.transfer, "address", $$v)
                                    },
                                    expression: "transfer.address"
                                  }
                                })
                              : _c("cu-field", {
                                  attrs: {
                                    name: "address",
                                    placeholder: "请输入地址",
                                    rules: [
                                      { required: true, message: "请输入地址" }
                                    ]
                                  },
                                  model: {
                                    value: _vm.transfer.address,
                                    callback: function($$v) {
                                      _vm.$set(_vm.transfer, "address", $$v)
                                    },
                                    expression: "transfer.address"
                                  }
                                })
                          ],
                          1
                        )
                      ]
                    : _vm.active === 2
                    ? [
                        _c(
                          "van-form",
                          {
                            ref: "ruleForm",
                            refInFor: true,
                            staticClass: "tab1Form deployForm"
                          },
                          [
                            _c("p", { staticClass: "tab1Form-item-label" }, [
                              _vm._v("币种"),
                              _c("span", [_vm._v("(必填)")])
                            ]),
                            _vm._v(" "),
                            _c("cu-field", {
                              attrs: {
                                name: "currency",
                                placeholder:
                                  "请输入最多4个英文字母字符，例如cdef",
                                rules: [
                                  { required: true, message: "请输入币种" },
                                  {
                                    validator: _vm.validatorWithCurrency,
                                    message: "请输入最多4个英文字母字符"
                                  }
                                ]
                              },
                              model: {
                                value: _vm.deploy.currency,
                                callback: function($$v) {
                                  _vm.$set(_vm.deploy, "currency", $$v)
                                },
                                expression: "deploy.currency"
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "tab1Form-item-label" }, [
                              _vm._v("ID")
                            ]),
                            _vm._v(" "),
                            _c("cu-field", {
                              attrs: {
                                name: "id",
                                placeholder: "请输入ID",
                                rules: [
                                  { required: true, message: "请输入币种" }
                                ]
                              },
                              model: {
                                value: _vm.deploy.id,
                                callback: function($$v) {
                                  _vm.$set(_vm.deploy, "id", $$v)
                                },
                                expression: "deploy.id"
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "tab1Form-item-label" }, [
                              _vm._v("发行总量"),
                              _c("span", [_vm._v("(必填)")])
                            ]),
                            _vm._v(" "),
                            _c("cu-field", {
                              attrs: {
                                name: "amount",
                                placeholder: "请输入发行总量",
                                rules: [
                                  { required: true, message: "请输入发行总量" }
                                ]
                              },
                              model: {
                                value: _vm.deploy.amount,
                                callback: function($$v) {
                                  _vm.$set(_vm.deploy, "amount", $$v)
                                },
                                expression: "deploy.amount"
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "tab1Form-item-label" }, [
                              _vm._v("单次锻造上限")
                            ]),
                            _vm._v(" "),
                            _c("van-field", {
                              attrs: {
                                name: "count",
                                placeholder: "请输入发行总量"
                              },
                              model: {
                                value: _vm.deploy.count,
                                callback: function($$v) {
                                  _vm.$set(_vm.deploy, "count", $$v)
                                },
                                expression: "deploy.count"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "tab1Form-item-label selectAddress"
                              },
                              [
                                _c("div", [
                                  _vm._v(_vm._s(_vm.inpWayText) + "接收地址"),
                                  _c("span", [_vm._v("(必填)")])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.changeInpAdWay()
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../assets/images/dmtAorrow.png")
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.selectWayText) +
                                        "接收地址\n                "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isSelect
                              ? _c("van-field", {
                                  attrs: {
                                    name: "address",
                                    readonly: "",
                                    clearable: "",
                                    rules: [
                                      { required: true, message: "请选择地址" }
                                    ],
                                    placeholder: "请选择地址"
                                  },
                                  on: { click: _vm.showAdSelect },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "button",
                                        fn: function() {
                                          return [
                                            _c("van-icon", {
                                              attrs: { name: "arrow-down" }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.deploy.address,
                                    callback: function($$v) {
                                      _vm.$set(_vm.deploy, "address", $$v)
                                    },
                                    expression: "deploy.address"
                                  }
                                })
                              : _c("cu-field", {
                                  attrs: {
                                    name: "address",
                                    placeholder: "请输入地址",
                                    rules: [
                                      { required: true, message: "请输入地址" }
                                    ]
                                  },
                                  model: {
                                    value: _vm.deploy.address,
                                    callback: function($$v) {
                                      _vm.$set(_vm.deploy, "address", $$v)
                                    },
                                    expression: "deploy.address"
                                  }
                                })
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ])
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cea0ce60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cea0ce60","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/InscriptionArea/compontents/brc20Tab.vue
// module id = +Jik
// module chunks = 0